var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMaitre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6475 8.44301L15.2925 4.79801C15.4795 4.61001 15.7345 4.505 15.9995 4.505C16.2645 4.505 16.5195 4.61001 16.7065 4.79801L20.3515 8.44301L15.9995 12.241L11.6475 8.44301Z",
    fill: "#AD9047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.342 8.94199C24.638 8.68399 25.057 8.62299 25.414 8.78499C25.771 8.94699 26 9.30299 26 9.69499C26 14.006 26 23.413 26 26.495C26 26.761 25.895 27.015 25.707 27.202C25.52 27.39 25.265 27.495 25 27.495H7C6.735 27.495 6.48 27.39 6.293 27.202C6.105 27.015 6 26.761 6 26.495V9.69499C6 9.30299 6.229 8.94699 6.586 8.78499C6.943 8.62299 7.362 8.68399 7.658 8.94199C10.5 11.422 16 16.222 16 16.222C16 16.222 21.5 11.422 24.342 8.94199Z",
    fill: "#FFD56A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H26",
    stroke: "#AD9047",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2921 15.293C15.4791 15.105 15.7341 15 15.9991 15C16.2641 15 16.5191 15.105 16.7061 15.293C17.6581 16.244 19.3401 17.927 20.2921 18.879C20.4791 19.066 20.5851 19.32 20.5851 19.586C20.5851 19.851 20.4791 20.105 20.2921 20.293C19.3401 21.244 17.6581 22.927 16.7061 23.879C16.5191 24.066 16.2641 24.171 15.9991 24.171C15.7341 24.171 15.4791 24.066 15.2921 23.879C14.3401 22.927 12.6581 21.244 11.7061 20.293C11.5191 20.105 11.4131 19.851 11.4131 19.586C11.4131 19.32 11.5191 19.066 11.7061 18.879C12.6581 17.927 14.3401 16.244 15.2921 15.293Z",
    fill: "#FF7575"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaitre);
export default __webpack_public_path__ + "static/media/icon_maitre.39dc1de0fb36571dbe7ec7782923ad34.svg";
export { ForwardRef as ReactComponent };